/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ContentItem from '../../components/ContentItemEnd';

class TagContent extends Component {
  state = {
    menuIndex: 0,
    slideIndex: 1,
    tagIndex: 0,
    slidePlay: true,
    mouseOn: false,
    onEvent: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getTag();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getTag = async () => {
    // const { loginId } = this.props;

    const result = await this._getTagApi();
    const intReturn = result.data[0].intReturn;
    const tagList = result.data[0].listData;
    let tagCode;

    if (intReturn === 0) {
      ////console.log(tagList)
      if (this._isMounted) {
        if (tagList.length > 0) {
          tagCode = tagList[0].tagCode;
        }
        this.setState({
          tagList,
          tagCode,
        });

        this._getContent(tagCode);
      }
    }
  };
  _getTagApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/tagList')
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getContent = async (tagCode) => {
    // const { loginId } = this.props;

    const result = await this._getContentApi(tagCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        contentList,
      });
    }
  };
  _getContentApi = (tagCode) => {
    const { apiUrl, loginId } = this.props;

    return axios(
      apiUrl + '/tagContent?tagCode=' + tagCode + '&userid=' + loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <div key={index}>
          <ContentItem
            refer={'sametime'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            num={index + 1}
            onEndItemSlide={this._onEndItemSlide}
            subTitle={item.subTitle}
            cashOnlay={item.cashOnly}
          />
        </div>
      );
    });

    return list;
  };
  _onEndItemSlide = (num, over) => {
    const { slideIndex } = this.state;
    let scrollPos;
    ////console.log(slideIndex)
    if (num === null || num === '' || num === undefined) {
      //console.log()
    } else {
      //console.log(over, num, slideIndex)
      if (over) {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 1;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 7;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 13;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 19;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      } else {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 0;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 6;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 12;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 18;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      }
    }
  };
  _onToggleMouseOn = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _onSelect = (key) => {
    //console.log(key)
  };
  _arrowNext = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    const page = Math.round(cnt / 6);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    // const cnt = contentList.length;
    // const page = Math.round(cnt / 6);

    //if(slideIndex < 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _renderDot = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    let page = Math.round(cnt / 6);
    if (page === 0) {
      page = 1;
    }
    //console.log(page, cnt)
    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _renderTag = () => {
    const { tagList, tagIndex } = this.state;

    const list = tagList.map((item, index) => {
      return (
        <span
          key={index}
          className={index === tagIndex ? 'on' : null}
          onClick={() => this._onTagClick(index, item.tagCode)}
        >
          #{item.tag}
        </span>
      );
    });

    return list;
  };
  _onTagClick = (index, tagCode) => {
    this.setState({
      tagIndex: index,
    });
    this._getContent(tagCode);
  };
  _onMore = () => {
    const { tagCode } = this.state;
    const { history } = this.props;
    history.push('/list?q=tag&c=' + tagCode);
  };
  render() {
    const { contentList, mouseOn, slideIndex, tagList } = this.state;
    return (
      <Fragment>
        {contentList ? (
          <div className="main_list_style m_taglist m_thumblist ">
            <h1>
              <strong>인기 태그 작품</strong>
              {tagList ? this._renderTag() : null}

              <div>
                {this._renderDot()}

                <a style={{ cursor: 'pointer' }} onClick={this._onMore}>
                  더보기
                </a>
              </div>
            </h1>
            <div
              className="main_list_goup1"
              onMouseEnter={this._onToggleMouseOn}
              onMouseLeave={this._onToggleMouseOff}
            >
              <div className="div_ul">
                <ScrollMenu
                  data={contentList ? this._renderItem() : null}
                  arrowLeft={
                    mouseOn ? (
                      slideIndex === 1 ? null : (
                        <a
                          className="left_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowPrev}
                        >
                          <span className={'on'}>이전</span>
                        </a>
                      )
                    ) : null
                  }
                  arrowRight={
                    mouseOn ? (
                      slideIndex > parseInt(contentList.length / 6) ? null : (
                        <a
                          className="right_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._arrowNext}
                        >
                          <span className={'on'}>다음</span>
                        </a>
                      )
                    ) : null
                  }
                  wheel={false}
                  dragging={true}
                  transition={0.5}
                  translate={2}
                  alignOnResize={true}
                  //inertiaScrolling={true}
                  //inertiaScrollingSlowdown={3}
                  //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                  alignCenter={false}
                  hideSingleArrow={true}
                  hideArrows={mouseOn}
                  ref={(ref) => (this.scrollMenu = ref)}
                  scrollBy={6}
                />
              </div>
              <div className="clear"></div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TagContent));
